'use strict';

var _ = require('lodash');
var SearchCriteriaService = function SearchCriteriaService($q, restangular, SearchCriteria, RsqlQuery, configurationService, momentService, ruleVisibilityService) {
  var searchDefaults = require('../config/defaults.json');
  var searchService = restangular.one('usersearch');
  function isSearchRuleDateType(type) {
    return !_.isUndefined(momentService.ruleTypeToConfig(type));
  }
  function toRequest(obj) {
    var rulesWithDatesSerialized = _.transform(obj.rules, function (result, entry) {
      var value = entry.clone();
      if (isSearchRuleDateType(value.valueType)) {
        value.leftOperand = value.leftOperand && value.leftOperand.toISOString();
        value.rightOperand = value.rightOperand && value.rightOperand.toISOString();
      }
      result.push(value);
    });
    return {
      id: obj.id,
      userId: configurationService.getUserId(),
      contextId: obj.context,
      mode: obj.customSearchMode,
      title: obj.name,
      value: {
        rules: rulesWithDatesSerialized
      }
    };
  }
  function fromResponse(response) {
    var rulesWithDateDeserialized = response.value && response.value.rules && _.transform(response.value.rules, function (result, entry) {
      if (isSearchRuleDateType(entry.valueType)) {
        var config = momentService.ruleTypeToConfig(entry.valueType);
        entry.leftOperand = entry.leftOperand && momentService.of(entry.leftOperand, config);
        entry.rightOperand = entry.rightOperand && momentService.of(entry.rightOperand, config);
      }
      result.push(entry);
    });
    return new SearchCriteria({
      id: response.id,
      context: response.contextId,
      customSearchMode: response.mode,
      name: response.title,
      rules: rulesWithDateDeserialized
    });
  }
  function save(criteria, overwrite) {
    var request = toRequest(criteria);
    delete request.id;
    if (overwrite) {
      return searchService.customPUT(request);
    } else {
      return searchService.customPOST(request);
    }
  }
  function get(screen) {
    var userId = configurationService.getUserId();
    var rsqlQuery = new RsqlQuery().is('userId').equalTo(userId).and().is('contextId').equalTo(screen).toString();
    return searchService.get({
      filter: rsqlQuery
    }).then(function (data) {
      return _.transform(data.userSearch, function (result, obj) {
        result.push(fromResponse(obj));
      });
    });
  }
  function getDefault(screen, mode, defaultListing) {
    var rules = searchDefaults[screen];
    if (_.isUndefined(rules)) {
      throw new Error('No default search criteria for ' + screen);
    }
    if (rules[0] && rules[0].preference && rules[0].preference === 'defaultList') {
      if (!defaultListing) {
        rules[0].leftOperand = '{{allUsers}}';
      } else {
        rules[0].leftOperand = '{{userId}}';
      }
    }
    _.remove(rules, function (rule) {
      return !ruleVisibilityService.isRuleVisible(rule.visibilityCondition);
    });
    return $q.when(new SearchCriteria({
      context: screen,
      customSearchMode: mode,
      rules: rules
    }));
  }
  return {
    save: save,
    get: get,
    getDefault: getDefault
  };
};
SearchCriteriaService.$inject = ['$q', 'Restangular', 'SearchCriteriaFactory', 'RsqlQueryFactory', 'ConfigurationService', 'MomentService', 'RuleVisibilityService'];
module.exports = SearchCriteriaService;